/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionPlusIcon20Light = forwardRef('TextActionPlusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M3.5 8a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" }),
        React.createElement("path", { d: "M3.5 12a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z" }),
        React.createElement("path", { d: "M15 11.5a.5.5 0 0 0-1 0V14h-2.5a.5.5 0 0 0 0 1H14v2.5a.5.5 0 0 0 1 0V15h2.5a.5.5 0 0 0 0-1H15v-2.5Z" })));
});
